import { connect } from 'react-redux'
import Constructor from './constructor'
import { withMe } from 'pobble-components/dist/pobble-user'
import { getFinishSignupStatus } from '../../../../common/api/me.selectors'
import fsuScreensMap from '../fsu-screens-map'
import { withRouter } from 'react-router-dom'

const mapStateToProps = (state, { me, meRequest, history }) => {
  if (meRequest.error) {
    if (meRequest.error.status === 401) {
      history.push('/')
    }
    return { Screen: fsuScreensMap.UnknownError, me }
  }

  const finishSignupStatus = getFinishSignupStatus(me)

  if (finishSignupStatus.finished) {
    return { Screen: fsuScreensMap.Finished, options: {}, me }
  }

  const Screen = fsuScreensMap[finishSignupStatus.next_step.type]
  return {
    Screen,
    options: finishSignupStatus.next_step.options,
    accountType: finishSignupStatus.next_step.signup_account_type_decision,
    forcedAccount: finishSignupStatus.next_step.signup_account_type_forced,
    me
  }
}

export default withRouter(
  withMe(
    connect(
      mapStateToProps,
      null
    )(Constructor)
  )
)
